import { useState } from 'react'
import UserRegistration from './pages/UserRegistration'
import AdminLogin from './pages/admin/AdminLogin'
import AdminDashboard from './pages/admin/AdminDashboard'

function AdminApp() {
  const [admin, setAdmin] = useState(() => {
    const saved = sessionStorage.getItem('admin')
    return saved ? JSON.parse(saved) : null
  })
  const handleLogout = () => {
    sessionStorage.removeItem('admin')
    setAdmin(null)
  }
  if (!admin) return <AdminLogin onLogin={setAdmin} />
  return <AdminDashboard admin={admin} onLogout={handleLogout} />
}

export default function App() {
  const hostname = window.location.hostname
  const isAdmin = hostname === 'admin.finconnectx.com'

  if (isAdmin) return <AdminApp />
  return <UserRegistration />
}